import * as types from '../actions/actionTypes'

/*
  createdCreamItem example: {
    "cream_item_id": "a7eaab44b7cb65a989ac7ac3f6b9400ff353615583b30a4b97646873", // 商品ID
    "name": "王小明",  // 賣家姓名
    "contact": "+886123456789",  // 賣家聯絡資訊 (若無手機號碼則為email，目前僅開放有手機號碼者才能開團)
    "title": "團購名稱",
    "price": 1000,     // 商品金額 (台幣/每份)
    "qty": 10,        // 可購買數量 (若無限制則為null)
    "instalment": 3,  // 分期期數
    "instalment_amount": 333, // 分期金額 (台幣/一期)
    "deadline": "2020-03-28T15:59:59.000Z",   // 購買截止日期 (UTC)
    "url": "https://xxx.com/169ffd0acc626e42", // QR Code的URL
    "loyalty_enabled": true
  }
*/

export const initialState = {
  createdCreamItem: null, // * createCreamItem response data
  slashInfo: null,
}

// slashInfo
// {
//   "exchange_rate": 30.00,  // 台幣兌美元匯率
//   "is_active": true,       // 目前是否開放開團/付款
//   "is_vendor": false       // 賣家是否為廠商 (因應Slash下線)
// }

export function createdCreamItemSelector(creator) {
  return creator.createdCreamItem
}

export function exchangeRateSelector(creator) {
  return creator.slashInfo ? creator.slashInfo.exchange_rate : 1
}

export function isVendorSelector(creator) {
  return creator.slashInfo ? creator.slashInfo.is_vendor : false
}

export default function creatorReducer(creator = initialState, action) {
  switch (action.type) {
    case types.CREATE_CREAM_ITEM_SUCCESS:
      return {
        ...creator,
        createdCreamItem: {
          ...action.payload,
          status: 'created',
        },
      }
    case types.MOVE_CREATED_ITEM_TO_LIST:
    case types.CREATE_CREAM_ITEM_ERROR:
      return {
        ...creator,
        createdCreamItem: null,
      }
    case types.TERMINATE_CREAM_ITEM_SUCCESS: {
      // * update 1 item:
      // * 1. createdCreamItem (if existed and itemId matches)
      const itemId = action.payload
      const { createdCreamItem } = creator

      // * for createdCreamItem:
      const newCreatedCreamItem =
        createdCreamItem && createdCreamItem.cream_item_id === itemId
          ? {
              ...createdCreamItem,
              status: 'terminated',
            }
          : createdCreamItem

      return {
        ...creator,
        createdCreamItem: newCreatedCreamItem,
      }
    }
    case types.GET_SLASH_INFO_SUCCESS:
      return {
        ...creator,
        slashInfo: action.payload,
      }
    case types.GET_SLASH_INFO_ERROR:
      return {
        ...creator,
        slashInfo: null,
      }
    default:
      return creator
  }
}
